import janJaap from "@/assets/authors/jan-jaap-bolkesteijn.webp.asset.json";
import robert from "@/assets/authors/robert-bemelmans.jpg.asset.json";
import wietse from "@/assets/authors/wietse-van-koppen.jpg.asset.json";
import naomi from "@/assets/authors/naomi-bootman.webp.asset.json";
import sander from "@/assets/authors/sander-overmars.webp.asset.json";
import tessa from "@/assets/authors/tessa-blokpoel.jpg.asset.json";
import dirk from "@/assets/authors/dirk-van-haaster.webp.asset.json";

export type Author = {
  slug: string;
  name: string;
  role: string;
  photo: string;
  expertise: string[];
  bio: string;
  since: string;
};

export const AUTHORS: Author[] = [
  {
    slug: "jan-jaap-bolkesteijn",
    name: "Jan Jaap Bolkesteijn",
    role: "Hoofdredacteur",
    photo: janJaap.url,
    expertise: ["Betaalmethoden", "Kansspelregelgeving", "Redactioneel beleid"],
    since: "2019",
    bio: "Jan Jaap leidt de redactie van Casino Betalingen en bewaakt de scheiding tussen commercie en redactie. Hij schrijft sinds 2019 over online betalen en volgt de Wwft en de PSD2-praktijk op de voet. Elke ranking op deze site wordt door hem afgetekend voordat die live gaat.",
  },
  {
    slug: "robert-bemelmans",
    name: "Robert Bemelmans",
    role: "Senior redacteur betaalmethoden",
    photo: robert.url,
    expertise: ["iDEAL", "Open banking", "Uitbetaaltijden"],
    since: "2020",
    bio: "Robert test wekelijks stortingen en opnames bij Nederlandse aanbieders en houdt de doorlooptijden per betaalmethode bij. Hij heeft een achtergrond in betaalverkeer bij een Nederlandse bank en vertaalt technische betaalketens naar begrijpelijke uitleg.",
  },
  {
    slug: "wietse-van-koppen",
    name: "Wietse van Koppen",
    role: "Factchecker",
    photo: wietse.url,
    expertise: ["Bronverificatie", "Vergunningen", "Voorwaarden"],
    since: "2021",
    bio: "Wietse controleert elk cijfer op deze site tegen de primaire bron: het vergunningenregister, de algemene voorwaarden van de aanbieder of de kassa zelf. Publiceert een pagina pas nadat de laatste controle is vastgelegd in de wijzigingsgeschiedenis.",
  },
  {
    slug: "naomi-bootman",
    name: "Naomi Bootman",
    role: "Redacteur verantwoord spelen",
    photo: naomi.url,
    expertise: ["Limieten", "Cruks", "Consumentenbescherming"],
    since: "2022",
    bio: "Naomi schrijft over speellimieten, stortlimieten en de praktijk van Cruks. Zij zorgt dat elke pagina eerlijk uitlegt wat een betaalmethode betekent voor je uitgavenpatroon en wanneer je beter kunt stoppen.",
  },
  {
    slug: "sander-overmars",
    name: "Sander Overmars",
    role: "Data-analist",
    photo: sander.url,
    expertise: ["Testdata", "Uitbetaalsnelheid", "Statistiek"],
    since: "2021",
    bio: "Sander beheert de testdatabase achter de casinozoeker. Hij verwerkt elke live test tot meetbare waarden: seconden tot creditering, uren tot uitbetaling en het percentage tests zonder extra verificatievraag.",
  },
  {
    slug: "tessa-blokpoel",
    name: "Tessa Blokpoel",
    role: "Redacteur e-wallets",
    photo: tessa.url,
    expertise: ["Skrill", "Neteller", "Kosten en wisselkoersen"],
    since: "2023",
    bio: "Tessa volgt de e-walletmarkt en rekent kosten, wisselkoersopslagen en inactiviteitstarieven na. Zij schrijft de vergelijkingen tussen wallets en bankmethoden.",
  },
  {
    slug: "dirk-van-haaster",
    name: "Dirk van Haaster",
    role: "Redacteur mobiel betalen",
    photo: dirk.url,
    expertise: ["Apple Pay", "Google Pay", "Mobiele kassa's"],
    since: "2022",
    bio: "Dirk test betaalstromen op iOS en Android en beoordeelt of een kassa daadwerkelijk een native integratie heeft of alleen een kaartformulier toont. Zijn tests bepalen welke aanbieders in onze mobiele filters verschijnen.",
  },
];

export function getAuthor(slug: string): Author | null {
  return AUTHORS.find((a) => a.slug === slug) ?? null;
}
